import type { InformationModalContentProps } from './index.tsx';

export const data: Record<
  'warranty' | 'membership',
  InformationModalContentProps
> = {
  warranty: {
    copy: 'ring_pdp_2025_warranty_modal_2_and_3_year_copy',
    eyebrow: 'ring_pdp_2025_warranty_modal_eyebrow',
    footnote: 'ring_pdp_2025_warranty_modal_footnote',
    heading: 'ring_pdp_2025_warranty_modal_2_and_3_year_heading',
    imageAlt: 'woman_close_up_image_alt',
    imageFormat: 'jpg',
    imageSrc: 'hardware-pdp/modal/warranty',
    title: 'ring_pdp_2025_warranty_modal_title',
  },
  membership: {
    copy: 'ring_pdp_2025_membership_modal_features_copy',
    footnote: 'ring_pdp_2025_membership_modal_footnote',
    heading: 'ring_pdp_2025_membership_modal_features_heading',
    imageAlt: 'man_smartphone_image_alt',
    imageFormat: 'jpg',
    imageSrc: 'hardware-pdp/modal/membership',
    title: 'ring_pdp_2025_membership_modal_title',
  },
} as const;
